import { useEffect, useState } from 'react';
import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import deDE from 'antd/locale/de_DE';
import ptBR from 'antd/locale/pt_BR';
import i18n from '../i18n/i18n';

const ANTD_LOCALES: Record<string, Locale> = {
  en: enUS,
  de: deDE,
  'pt-BR': ptBR,
};

export const useAntdLocale = (): Locale => {
  const [antdLocale, setAntdLocale] = useState<Locale>(
    ANTD_LOCALES[i18n.language] ?? enUS
  );

  useEffect(() => {
    const handleLanguageChange = (lang: string) => {
      setAntdLocale(ANTD_LOCALES[lang] ?? enUS);
    };
    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return antdLocale;
};
